var _defs, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _path2, _path3, _path4, _path5, _path6, _path7, _g9, _path8, _g10, _g11, _g12, _path9, _path10, _path11, _path12, _path13, _g13, _path14, _g14, _path15, _g15, _path16, _path17, _path18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIbPhase1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 456.04 818.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .ib-disable-phase-1{\n        fill: #edeef0 !important; \n      }\n      .ib-disable-phase-1:hover {\n        pointer-events: none;\n        fill: #edeef0 !important; \n      }\n      .ib-diamond-disable-phase-1{\n        fill: #a3ceff !important\n      }\n      .ib-diamond-disable-phase-1:hover {\n        pointer-events: none;\n        fill: #a3ceff !important  \n      }\n      .ib-phase-1-1, .ib-phase-1-2, .ib-phase-1-3, .ib-phase-1-4, .ib-phase-1-5 {\n        stroke: #1071e5;\n      }\n\n      .ib-phase-1-1, .ib-phase-1-6 {\n        fill: #fff;\n      }\n\n      .ib-phase-1-2, .ib-phase-1-3, .ib-phase-1-7 {\n        fill: #1071e5;\n      }\n\n      .ib-phase-1-8 {\n        fill: rgba(255, 255, 255, 0);\n        stroke: rgba(0, 0, 0, 0);\n      }\n\n      .ib-phase-1-3 {\n        stroke-width: .05px;\n      }\n\n      .ib-phase-1-6, .ib-phase-1-9, .ib-phase-1-7, .ib-phase-1-10, .ib-phase-1-11 {\n        stroke-width: 0px;\n      }\n\n      .ib-phase-1-9 {\n        fill: #3a414a;\n      }\n\n      .ib-phase-1-10 {\n        fill: #e81313;\n      }\n\n      .ib-phase-1-11 {\n        fill: #008a0e;\n      }\n\n      .ib-phase-1-4 {\n        fill: none;\n      }\n\n      .ib-phase-1-5 {\n        fill: url(#linear-gradient-ib-phase-1);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-ib-phase-1",
    x1: 318.21,
    y1: 560.75,
    x2: 318.21,
    y2: 392.1,
    gradientTransform: "translate(-146.57 1010.09) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#6db1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1071e5"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "rect-1",
    className: "ib-phase-1-1",
    d: "M2.65,6.5C2.65,3.19,5.34.5,8.65.5h330.25c3.31,0,6,2.69,6,6v212.52c0,3.31-2.69,6-6,6H8.65c-3.31,0-6-2.69-6-6V6.5Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "t",
    className: "ib-phase-1-9",
    d: "M100.24,46.21c2.38.34,4.14,1.56,4.14,4.14,0,5.91-7.2,4.62-12.97,4.75v-16.84c5.16.2,12.02-1.15,12.02,4.07,0,2.24-1.29,3.4-3.19,3.87ZM93.65,45.47c3.4-.07,7.47.61,7.47-2.85,0-3.19-4.28-2.44-7.47-2.51v5.36ZM93.65,53.28c3.73-.14,8.42.95,8.42-3.06s-4.75-2.85-8.42-2.99v6.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u",
    className: "ib-phase-1-9",
    d: "M113.41,44.04c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v",
    className: "ib-phase-1-9",
    d: "M115.38,39.42v-2.04h2.17v2.04h-2.17ZM115.38,55.11v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w",
    className: "ib-phase-1-9",
    d: "M125.91,41.94c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM129.44,47.44c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "x",
    className: "ib-phase-1-9",
    d: "M139.55,39.22c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v-2",
    "data-name": "v",
    className: "ib-phase-1-9",
    d: "M141.12,39.42v-2.04h2.17v2.04h-2.17ZM141.12,55.11v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y",
    className: "ib-phase-1-9",
    d: "M152.79,41.94c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "z",
    className: "ib-phase-1-9",
    d: "M170.45,42.21c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM164.81,53.62c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "A",
    className: "ib-phase-1-9",
    d: "M185.32,43.63c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "B",
    className: "ib-phase-1-9",
    d: "M197.81,41.94c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM197.75,53.75c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y-2",
    "data-name": "y",
    className: "ib-phase-1-9",
    d: "M212.55,41.94c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C",
    className: "ib-phase-1-9",
    d: "M222.19,51.92c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w-2",
    "data-name": "w",
    className: "ib-phase-1-9",
    d: "M231.76,41.94c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM235.29,47.44c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y-3",
    "data-name": "y",
    className: "ib-phase-1-9",
    d: "M246.5,41.94c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C-2",
    "data-name": "C",
    className: "ib-phase-1-9",
    d: "M256.14,51.92c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "A-2",
    "data-name": "A",
    className: "ib-phase-1-9",
    d: "M62.62,84.7c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "B-2",
    "data-name": "B",
    className: "ib-phase-1-9",
    d: "M75.12,83c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM75.05,94.82c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y-4",
    "data-name": "y",
    className: "ib-phase-1-9",
    d: "M89.85,83c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "D",
    className: "ib-phase-1-9",
    d: "M104.65,86.47c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "B-3",
    "data-name": "B",
    className: "ib-phase-1-9",
    d: "M114.5,83c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM114.43,94.82c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "E",
    className: "ib-phase-1-9",
    d: "M122.92,96.18v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v-3",
    "data-name": "v",
    className: "ib-phase-1-9",
    d: "M128.28,80.49v-2.04h2.17v2.04h-2.17ZM128.28,96.18v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "F",
    className: "ib-phase-1-9",
    d: "M137.79,83c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM138.4,84.63c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "G",
    className: "ib-phase-1-9",
    d: "M155.17,93.73c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM148.86,92.58c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C-3",
    "data-name": "C",
    className: "ib-phase-1-9",
    d: "M163.18,92.99c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w-3",
    "data-name": "w",
    className: "ib-phase-1-9",
    d: "M172.76,83c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM176.29,88.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "F-2",
    "data-name": "F",
    className: "ib-phase-1-9",
    d: "M185.32,83c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM185.93,84.63c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    id: "H",
    className: "ib-phase-1-9",
    d: "M207.73,83c3.6,0,4.69,2.65,4.75,6.65,0,4.48-1.56,6.79-4.75,6.79-2.1-.07-3.33-.75-4.01-2.31l-.14,2.04h-2.1l.07-17.72h2.17v6.86c.68-1.56,1.9-2.31,4.01-2.31ZM207.18,94.82c2.72,0,3.06-2.31,3.06-5.09s-.34-5.09-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w-4",
    "data-name": "w",
    className: "ib-phase-1-9",
    d: "M220.29,83c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM223.82,88.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C-4",
    "data-name": "C",
    className: "ib-phase-1-9",
    d: "M231.09,92.99c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "I",
    className: "ib-phase-1-9",
    d: "M247.86,96.18h-2.44l-2.72-11.14-2.78,11.14h-2.44l-3.67-12.9h2.17l2.65,11.14,2.92-11.14h2.31l2.78,11.14,2.85-11.14h2.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w-5",
    "data-name": "w",
    className: "ib-phase-1-9",
    d: "M258.25,83c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM261.78,88.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w-6",
    "data-name": "w",
    className: "ib-phase-1-9",
    d: "M271.83,83c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM275.36,88.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y-5",
    "data-name": "y",
    className: "ib-phase-1-9",
    d: "M286.56,83c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    id: "J",
    className: "ib-phase-1-9",
    d: "M84.04,137.24l.14-14.8c-1.56,5.16-3.67,9.85-5.43,14.8h-1.56l-5.5-14.8.07,14.8h-1.97v-16.84h2.99l5.23,14.33c1.43-5.09,3.46-9.51,5.16-14.33h2.92v16.84h-2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "G-2",
    "data-name": "G",
    className: "ib-phase-1-9",
    d: "M97.63,134.8c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM91.31,133.64c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C-5",
    "data-name": "C",
    className: "ib-phase-1-9",
    d: "M105.64,134.05c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w-7",
    "data-name": "w",
    className: "ib-phase-1-9",
    d: "M115.21,124.07c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM118.74,129.57c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u-2",
    "data-name": "u",
    className: "ib-phase-1-9",
    d: "M129.74,126.18c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v-4",
    "data-name": "v",
    className: "ib-phase-1-9",
    d: "M131.71,121.56v-2.04h2.17v2.04h-2.17ZM131.71,137.24v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "G-3",
    "data-name": "G",
    className: "ib-phase-1-9",
    d: "M145.02,134.8c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM138.71,133.64c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "E-2",
    "data-name": "E",
    className: "ib-phase-1-9",
    d: "M150.66,137.24v-17.72h2.17v17.72h-2.17"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    id: "K",
    className: "ib-phase-1-9",
    d: "M170.69,120.2c5.5,0,8.35,3.12,8.35,8.56s-2.99,8.76-8.35,8.76-8.35-3.33-8.35-8.76,2.85-8.56,8.35-8.56ZM170.69,135.61c4.28,0,6.04-2.78,6.04-6.86s-1.97-6.72-6.04-6.72-6.04,2.65-6.04,6.72,1.9,6.79,6.04,6.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "I-2",
    "data-name": "I",
    className: "ib-phase-1-9",
    d: "M194.18,137.24h-2.44l-2.72-11.14-2.78,11.14h-2.44l-3.67-12.9h2.17l2.65,11.14,2.92-11.14h2.31l2.78,11.14,2.85-11.14h2.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y-6",
    "data-name": "y",
    className: "ib-phase-1-9",
    d: "M205.72,124.07c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w-8",
    "data-name": "w",
    className: "ib-phase-1-9",
    d: "M218.15,124.07c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM221.68,129.57c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u-3",
    "data-name": "u",
    className: "ib-phase-1-9",
    d: "M232.68,126.18c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    id: "G-4",
    "data-name": "G",
    className: "ib-phase-1-9",
    d: "M249.38,134.8c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM243.07,133.64c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y-7",
    "data-name": "y",
    className: "ib-phase-1-9",
    d: "M261.34,124.07c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "F-3",
    "data-name": "F",
    className: "ib-phase-1-9",
    d: "M272.74,124.07c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM273.35,125.7c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    id: "u-4",
    "data-name": "u",
    className: "ib-phase-1-9",
    d: "M135.85,167.24c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w-9",
    "data-name": "w",
    className: "ib-phase-1-9",
    d: "M142.98,165.14c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM146.51,170.64c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L",
    className: "ib-phase-1-9",
    d: "M157.11,178.31h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v-5",
    "data-name": "v",
    className: "ib-phase-1-9",
    d: "M163.63,162.62v-2.04h2.17v2.04h-2.17ZM163.63,178.31v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w-10",
    "data-name": "w",
    className: "ib-phase-1-9",
    d: "M174.15,165.14c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM177.68,170.64c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "I-3",
    "data-name": "I",
    className: "ib-phase-1-9",
    d: "M194.93,178.31h-2.44l-2.72-11.14-2.78,11.14h-2.44l-3.67-12.9h2.17l2.65,11.14,2.92-11.14h2.31l2.78,11.14,2.85-11.14h2.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w-11",
    "data-name": "w",
    className: "ib-phase-1-9",
    d: "M205.32,165.14c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM208.85,170.64c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u-5",
    "data-name": "u",
    className: "ib-phase-1-9",
    d: "M219.85,167.24c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-1-4",
    d: "M173.78,226.02v44.94"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-1-3",
    d: "M174.28,226.04h-1v-.52h1v.52Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-1-2",
    d: "M173.78,285.73l-4.64-14.27h9.29l-4.65,14.27Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-1-3",
    d: "M172.13,698h-1v-23.3h1v23.3ZM172.13,645.36h-1v-29.2h1v29.2ZM172.13,616.16h-1v-3.5h1v3.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-1-7",
    d: "M171.63,712.76l-4.64-14.27h9.27l-4.63,14.27Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-1-3",
    d: "M171.63,714.37l-5.33-16.38h10.65l-5.32,16.38ZM167.68,698.99l3.95,12.14,3.94-12.15h-7.89Z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    id: "M",
    className: "ib-phase-1-11",
    d: "M156.49,657.92v6.99h-2.31v-6.99l-6.45-9.85h2.51l5.09,8.01,5.09-8.01h2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N",
    className: "ib-phase-1-11",
    d: "M165.52,664.91v-16.84h12.7v1.9h-10.46v5.36h9.78v1.83h-9.78v5.91h11v1.83h-13.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O",
    className: "ib-phase-1-11",
    d: "M192.34,652.08c-.34-3.26-8.35-3.67-8.42.14.95,5.09,10.73.95,11.07,8.08.2,5.3-8.22,5.91-11.88,3.73-1.15-.68-1.9-1.77-2.24-3.12l2.24-.48c.34,3.8,9.57,4.28,9.57-.07,0-5.3-10.52-.95-11-8.01-.34-5.57,9.85-5.7,12.15-2.31.34.48.54,1.09.75,1.7"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "ib-diamond-disable-phase-1",
    d: "M166.25,452c3.39-1.67,7.37-1.67,10.76,0l160.36,79c1.47.72,2.08,2.49,1.36,3.96-.29.59-.77,1.07-1.36,1.36l-160.36,79.02c-3.39,1.67-7.37,1.67-10.76,0L5.88,536.32c-1.46-.73-2.06-2.51-1.33-3.97.29-.58.75-1.04,1.33-1.33l160.37-79.02Z"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    id: "P",
    className: "ib-phase-1-6",
    d: "M120.68,510.47c2.38.34,4.14,1.56,4.14,4.14,0,5.91-7.2,4.62-12.97,4.75v-16.84c5.16.2,12.02-1.15,12.02,4.07,0,2.24-1.29,3.4-3.19,3.87ZM114.1,509.72c3.4-.07,7.47.61,7.47-2.85,0-3.19-4.28-2.44-7.47-2.51v5.36ZM114.1,517.53c3.73-.14,8.42.95,8.42-3.06s-4.75-2.85-8.42-2.99v6.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Q",
    className: "ib-phase-1-6",
    d: "M133.85,508.29c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "R",
    className: "ib-phase-1-6",
    d: "M135.82,503.68v-2.04h2.17v2.04h-2.17ZM135.82,519.36v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "S",
    className: "ib-phase-1-6",
    d: "M146.35,506.19c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM149.88,511.69c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "T",
    className: "ib-phase-1-6",
    d: "M160,503.47c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    id: "U",
    className: "ib-phase-1-6",
    d: "M183.02,519.36l.14-14.8c-1.56,5.16-3.67,9.85-5.43,14.8h-1.56l-5.5-14.8.07,14.8h-1.97v-16.84h2.99l5.23,14.33c1.43-5.09,3.46-9.51,5.16-14.33h2.92v16.84h-2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "S-2",
    "data-name": "S",
    className: "ib-phase-1-6",
    d: "M193.81,506.19c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM197.34,511.69c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "S-3",
    "data-name": "S",
    className: "ib-phase-1-6",
    d: "M207.39,506.19c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM210.92,511.69c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "V",
    className: "ib-phase-1-6",
    d: "M218.19,516.17c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "W",
    className: "ib-phase-1-6",
    d: "M230.14,509.65c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    id: "X",
    className: "ib-phase-1-6",
    d: "M96.85,560.43v-16.84h12.7v1.9h-10.46v5.36h9.78v1.83h-9.78v5.91h11v1.83h-13.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Y",
    className: "ib-phase-1-6",
    d: "M120.68,560.43l-3.46-5.3-3.53,5.3h-2.31l4.62-6.65-4.41-6.25h2.38l3.26,5.02,3.19-5.02h2.38l-4.35,6.25,4.62,6.65h-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Z",
    className: "ib-phase-1-6",
    d: "M131.14,547.25c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM130.6,559.07c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "S-4",
    "data-name": "S",
    className: "ib-phase-1-6",
    d: "M143.7,547.25c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM147.23,552.75c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aa",
    className: "ib-phase-1-6",
    d: "M157.01,548.95c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "V-2",
    "data-name": "V",
    className: "ib-phase-1-6",
    d: "M166.72,557.24c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab",
    className: "ib-phase-1-6",
    d: "M179.08,557.98c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM172.76,556.83c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "V-3",
    "data-name": "V",
    className: "ib-phase-1-6",
    d: "M187.09,557.24c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "R-2",
    "data-name": "R",
    className: "ib-phase-1-6",
    d: "M191.5,544.74v-2.04h2.17v2.04h-2.17ZM191.5,560.43v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac",
    className: "ib-phase-1-6",
    d: "M202.03,547.25c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM201.96,559.07c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad",
    className: "ib-phase-1-6",
    d: "M216.76,547.25c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "W-2",
    "data-name": "W",
    className: "ib-phase-1-6",
    d: "M231.56,550.72c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae",
    className: "ib-phase-1-6",
    d: "M241.61,543.38c5.7,0,7.54,6.59,3.06,9.03-1.29.68-2.51,1.63-2.65,3.53h-2.1c0-4.28,5.23-3.73,5.23-7.74,0-2.04-1.43-2.85-3.53-2.92-2.17,0-3.6,1.15-3.8,3.12l-2.17-.14c.48-3.06,2.31-4.89,5.98-4.89ZM239.85,560.43v-2.38h2.31v2.38h-2.31"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-1-3",
    d: "M367.67,534.16h-27.64v-1h27.64v1ZM450.53,112.35l1,.23.95.4.87.53.77.66.65.78.54.87.38.95.24,1,.08,1v408.93l-.08,1-.24,1-.4.94-.52.87-.67.76-.78.66-.87.54-.94.4-1,.23-1,.06h-45.26v-1h45.24l.88-.06.83-.2.8-.34.73-.45.65-.55.56-.65.46-.74.33-.8.2-.83.07-.88V118.78l-.07-.88-.2-.84-.34-.8-.46-.73-.56-.66-.65-.56-.74-.44-.8-.33-.84-.2-.88-.07h-87.72v-1h87.75l1.04.08Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-1-7",
    d: "M340.03,534.16h-.56l.06-.5-.06-.5h.57v1Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-1-3",
    d: "M340.06,534.2h-.63l.07-.54-.06-.52h.63v1.06ZM339.5,533.2l.05.46-.05.48h.5v-.95h-.5Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-1-7",
    d: "M361.29,117.4l-14.27-4.64,14.26-4.64v9.28Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-1-3",
    d: "M361.79,118.08l-16.4-5.32,16.4-5.33v10.65ZM348.64,112.76l12.16,3.95v-7.9l-12.16,3.95Z"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    id: "af",
    className: "ib-phase-1-10",
    d: "M380.57,538.55l-8.96-14.33.07,14.33h-1.97v-16.84h2.65l9.03,14.46-.14-14.46h2.1v16.84h-2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag",
    className: "ib-phase-1-10",
    d: "M394.77,521.51c5.5,0,8.35,3.12,8.35,8.56s-2.99,8.76-8.35,8.76-8.35-3.33-8.35-8.76,2.85-8.56,8.35-8.56ZM394.77,536.92c4.28,0,6.04-2.78,6.04-6.86s-1.97-6.72-6.04-6.72-6.04,2.65-6.04,6.72,1.9,6.79,6.04,6.86"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "ib-disable-phase-1",
    d: "M.5,293.85c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v86.66c0,3.31-2.69,6-6,6H6.5c-3.31,0-6-2.69-6-6v-86.66Z"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    id: "t-2",
    "data-name": "t",
    className: "ib-phase-1-9",
    d: "M119.01,334.29c2.16.31,3.77,1.42,3.77,3.77,0,5.37-6.54,4.2-11.79,4.32v-15.31c4.69.19,10.93-1.05,10.93,3.7,0,2.04-1.17,3.09-2.9,3.52ZM113.02,333.61c3.09-.06,6.79.56,6.79-2.59,0-2.9-3.89-2.22-6.79-2.28v4.88ZM113.02,340.71c3.4-.12,7.65.86,7.65-2.78s-4.32-2.59-7.65-2.72v5.49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u-6",
    "data-name": "u",
    className: "ib-phase-1-9",
    d: "M130.98,332.31c-4.81-.99-3.27,5.62-3.52,10.06h-1.98l-.06-11.73h1.85c.06.74-.06,1.79.12,2.41.37-1.67,1.42-3.02,3.58-2.53v1.79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v-6",
    "data-name": "v",
    className: "ib-phase-1-9",
    d: "M132.77,328.12v-1.85h1.98v1.85h-1.98ZM132.77,342.38v-11.73h1.98v11.73h-1.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w-12",
    "data-name": "w",
    className: "ib-phase-1-9",
    d: "M142.34,330.4c3.89,0,5.31,2.59,5.19,6.54h-8.33c0,2.47.86,4.14,3.27,4.2,1.6.06,2.65-.74,3.02-1.79l1.73.49c-.68,1.73-2.28,2.78-4.75,2.78-3.58,0-5.43-2.28-5.37-6.17.06-3.77,1.6-6.05,5.25-6.05ZM145.55,335.4c.37-3.7-4.69-4.75-5.99-1.73-.19.43-.37,1.05-.37,1.73h6.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "x-2",
    "data-name": "x",
    className: "ib-phase-1-9",
    d: "M154.75,327.93c-1.91-.56-2.59.62-2.35,2.72h2.35v1.42h-2.35v10.31h-1.91v-10.31h-1.67v-1.42h1.67c-.43-3.21,1.05-5.06,4.26-4.2v1.48"
  })), /*#__PURE__*/React.createElement("g", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    id: "A-3",
    "data-name": "A",
    className: "ib-phase-1-9",
    d: "M166.79,331.94c-2.47,0-2.96,2.04-2.96,4.51s.56,4.63,2.96,4.63c1.48,0,2.53-.86,2.65-2.35l1.98.12c-.37,2.28-1.91,3.77-4.57,3.77-3.64,0-4.69-2.53-5.06-6.11-.62-5.74,6.23-8.09,9.07-3.95.25.43.31.86.43,1.36l-1.98.19c-.25-1.3-.99-2.16-2.53-2.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u-7",
    "data-name": "u",
    className: "ib-phase-1-9",
    d: "M179.01,332.31c-4.81-.99-3.27,5.62-3.52,10.06h-1.98l-.06-11.73h1.85c.06.74-.06,1.79.12,2.41.37-1.67,1.42-3.02,3.58-2.53v1.79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w-13",
    "data-name": "w",
    className: "ib-phase-1-9",
    d: "M185.49,330.4c3.89,0,5.31,2.59,5.19,6.54h-8.33c0,2.47.86,4.14,3.27,4.2,1.6.06,2.65-.74,3.02-1.79l1.73.49c-.68,1.73-2.28,2.78-4.75,2.78-3.58,0-5.43-2.28-5.37-6.17.06-3.77,1.6-6.05,5.25-6.05ZM188.7,335.4c.37-3.7-4.69-4.75-5.99-1.73-.19.43-.37,1.05-.37,1.73h6.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "G-5",
    "data-name": "G",
    className: "ib-phase-1-9",
    d: "M200.37,340.15c-.93,1.3-1.91,2.53-4.2,2.47-2.22-.06-3.58-1.3-3.58-3.52-.06-3.95,3.89-3.89,7.72-3.89.19-2.16-.56-3.33-2.53-3.33-1.48.06-2.53.43-2.59,1.91l-2.04-.19c.31-2.28,2.04-3.21,4.69-3.21s4.44,1.23,4.44,3.95v5.06c-.06,1.23.43,1.98,1.73,1.67v1.23c-1.91.56-3.77-.12-3.64-2.16ZM194.62,339.1c0,1.23.74,2.04,1.98,2.04,2.53-.19,3.89-1.79,3.7-4.57-2.65.12-5.68-.31-5.68,2.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C-6",
    "data-name": "C",
    className: "ib-phase-1-9",
    d: "M207.65,339.47c-.12,1.48,1.11,1.79,2.35,1.36v1.48c-2.04.62-4.32.31-4.32-2.41v-7.84h-1.36v-1.42h1.48l.56-2.65h1.3v2.65h2.16v1.42h-2.16v7.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w-14",
    "data-name": "w",
    className: "ib-phase-1-9",
    d: "M216.35,330.4c3.89,0,5.31,2.59,5.19,6.54h-8.33c0,2.47.86,4.14,3.27,4.2,1.6.06,2.65-.74,3.02-1.79l1.73.49c-.68,1.73-2.28,2.78-4.75,2.78-3.58,0-5.43-2.28-5.37-6.17.06-3.77,1.6-6.05,5.25-6.05ZM219.56,335.4c.37-3.7-4.69-4.75-5.99-1.73-.19.43-.37,1.05-.37,1.73h6.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "F-4",
    "data-name": "F",
    className: "ib-phase-1-9",
    d: "M227.77,330.4c1.91,0,2.96.8,3.7,2.04l-.06-6.17h1.98l.06,16.11h-1.85c-.12-.62,0-1.42-.19-1.91-.62,1.42-1.73,2.16-3.64,2.16-3.27,0-4.26-2.41-4.32-6.05,0-4.07,1.42-6.17,4.32-6.17ZM228.33,331.88c-2.47,0-2.84,2.1-2.84,4.63s.37,4.57,2.78,4.57c2.59,0,3.15-1.98,3.15-4.69s-.56-4.57-3.09-4.51"
  })))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "rect-2",
    className: "ib-phase-1-8",
    d: "M.5,720.37c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v92c0,3.31-2.69,6-6,6H6.5c-3.31,0-6-2.69-6-6v-92Z"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ah",
    className: "ib-phase-1-9",
    d: "M112.21,759.57c-.07-2.92-6.38-3.12-6.59-.2,1.22,4.48,10.25.68,10.46,7.74.2,6.45-11.2,6.31-13.85,2.44-.41-.54-.68-1.29-.81-2.04l3.4-.54c.2,3.12,7.6,3.8,7.88.34-1.15-4.69-10.19-.68-10.46-7.74-.27-5.91,10.39-5.98,12.77-2.38.34.54.54,1.22.68,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ai",
    className: "ib-phase-1-9",
    d: "M129.6,768.67c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM126.54,763.99c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ai-2",
    "data-name": "ai",
    className: "ib-phase-1-9",
    d: "M143.18,768.67c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM140.12,763.99c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  })), /*#__PURE__*/React.createElement("g", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aj",
    className: "ib-phase-1-9",
    d: "M152.62,755.09c6.31.07,13.99-1.09,13.85,5.36-.07,5.09-4.69,5.98-10.32,5.57v5.91h-3.53v-16.84ZM156.15,763.31c3.19,0,6.79.48,6.79-2.78s-3.67-2.65-6.79-2.65v5.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak",
    className: "ib-phase-1-9",
    d: "M175.02,761.27c-4.01,0-2.31,6.59-2.65,10.66h-3.4v-17.72h3.4l-.07,7.4c.81-1.77,1.9-2.78,4.14-2.85,5.84-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "al",
    className: "ib-phase-1-9",
    d: "M191.18,769.62c-1.09,1.29-2.04,2.65-4.35,2.58-2.51-.07-3.94-1.36-3.94-3.94-.07-4.07,3.73-4.28,7.88-4.14.07-1.77-.2-3.19-1.9-3.19-1.22.07-1.77.61-1.9,1.83l-3.53-.14c.48-2.58,2.44-3.94,5.57-3.87s5.02,1.49,5.09,4.62l.07,5.57c-.07.95.81,1.22,1.7,1.02v1.83c-2.04.54-4.82.34-4.69-2.17ZM187.92,769.83c1.97,0,2.92-1.63,2.85-3.87-2.17,0-4.48-.2-4.41,2.04,0,1.15.54,1.83,1.56,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "am",
    className: "ib-phase-1-9",
    d: "M205.04,762.56c.07-1.97-4.75-2.31-4.82-.27,1.02,3.12,8.01.48,8.08,5.84.07,5.64-11.14,5.16-11.68.61l2.92-.48c.27,1.29,1.36,1.7,2.99,1.7,2.24.54,3.87-2.04,1.63-2.78-2.92-.95-6.93-.75-7.06-4.48-.14-5.43,10.46-5.02,10.93-.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ai-3",
    "data-name": "ai",
    className: "ib-phase-1-9",
    d: "M221.87,768.67c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27ZM218.82,763.99c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  })), /*#__PURE__*/React.createElement("g", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    id: "an",
    className: "ib-phase-1-9",
    d: "M242.04,759.57c0,5.3-5.7,5.84-7.54,9.57h7.81v2.78h-11.81c-.41-6.86,6.72-6.79,8.15-12.22.07-1.49-.81-2.1-2.24-2.17-1.56,0-2.17.95-2.38,2.31l-3.33-.2c.34-3.06,2.17-4.75,5.7-4.75s5.64,1.49,5.64,4.69"
  })))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-1-4",
    d: "M171.63,387.5v46.35"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-1-3",
    d: "M172.13,387.53h-1v-.52h1v.52Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "ib-phase-1-2",
    d: "M171.63,448.6l-4.64-14.25h9.27l-4.63,14.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIbPhase1);
export default __webpack_public_path__ + "static/media/IB-Phase-1.fb902e898d1d6075b2f1cbef3c03ea30.svg";
export { ForwardRef as ReactComponent };